import React from "react";

export default ({ kick }) => (
  <div className="swiper-slide">
  	<img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/fetus-kick.png" alt="Fetus Kick" title="Fetus Kick" />
    <span className="kick-count M14_9a2037">{kick}</span>
  </div>
);
